// Tiny module-level emitter for in-app alert toasts. The global watcher emits;
// <AlertToastLayer/> (mounted once in the app layout) subscribes and renders.
// Decoupled this way so the watcher has no React-tree dependency on the layer.

export interface AlertToastData {
  id: number;
  /** Saved-view name that matched. */
  viewName: string;
  /** Headline, e.g. "TSLA +15.2%" or "3 new hits". */
  title: string;
  /** Secondary line, e.g. "Gap & Go · $12.45" or "TSLA, AAPL, MSFT". */
  body: string;
}

type Listener = (t: AlertToastData) => void;
const listeners = new Set<Listener>();
let seq = 0;

export function emitAlertToast(t: Omit<AlertToastData, 'id'>): void {
  const full: AlertToastData = { ...t, id: ++seq };
  listeners.forEach((l) => l(full));
}

export function subscribeAlertToast(l: Listener): () => void {
  listeners.add(l);
  return () => {
    listeners.delete(l);
  };
}
